module.exports = __webpack_public_path__ + "img/connect_it.be1d41c2.png";